import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, Grid, Divider } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  outerCircle: {
    border: '1px solid rgba(0, 0, 0, 0.65)',
    borderRadius: '50%',
    minWidth: '35px',
    maxWidth: '35px',
    minHeight: '35px',
    maxHeight: '35px',
    textAlign: 'center',
    display: 'inline-block',
  },
  circleText: {
    position: 'relative',
    top: `${35 * 0.24}px`,
    fontSize: `${35 * 0.45}px`,
    lineHeight: `${35 * 0.5}px`,
    fontWeight: '700',
  },
  listItem: {
    width: '100%',
    padding: '0em',
  },
  statusText: {
    marginLeft: '0.2em',
  },
  statusItem: {
    margin: '0.5em 0em',
  },
}));

// take in data that looks like this:
// data = [
//   { status: 'New', count: 5, color: 'green' },
//   { status: 'Flagged', count: 2, color: 'red' },
// ];

const StatusView = (data) => {
  const classes = useStyles();

  const { status, count, color } = data;
  return (
    <Grid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
      className={classes.statusItem}
    >
      <span className={classes.outerCircle} style={{ backgroundColor: color }}>
        <span className={classes.circleText}>{count}</span>
      </span>
      <div className={classes.statusText}>{status}</div>
    </Grid>
  );
};

const QuoteRequestOverview = ({
  totalRequestsCount,
  requestBreakdownData = null,
}) => {
  const classes = useStyles();
  return (
    <div>
      <ListItem className={classes.listItem}>
        <Grid container direction="column" justify="center" alignItems="center">
          <Grid item>
            {StatusView({ count: totalRequestsCount, status: 'All Requests' })}
          </Grid>
        </Grid>
      </ListItem>
      {requestBreakdownData && (
        <div>
          <Divider />
          <ListItem className={classes.listItem}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                {requestBreakdownData.map((data) => StatusView(data))}
              </Grid>
            </Grid>
          </ListItem>
        </div>
      )}
    </div>
  );
};

export default QuoteRequestOverview;
